import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import CourseOneMain from "./CourseOneMain";

const CourseOne = () => (
  <>
    <Header />
    <CourseOneMain />
    <Footer />
  </>
);

export default CourseOne;
